import { useTranslation } from 'react-i18next';
import '../../styles/inputs/multiInput.scss';
import MainSquareButton from '../buttons/MainSquareButton';
import { crossSVG, plusSignSVG } from '../../lib/allCustomSVGs';
import CustomSVGs from '../customSVGs/CustomSVGs';

type Props = {
  mainTitle: string;
  mainButtonText: string;
  inputPlaceholder: string;
  values: string[];
  onChange: (values: string[]) => void;
};

const MultiInput = ({
  mainTitle,
  mainButtonText,
  inputPlaceholder,
  values,
  onChange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className='multiInput'>
      <div className='multiInput__top'>
        <span className='multiInput__top--title'>{t(`${mainTitle}`)}</span>
        <MainSquareButton
          value={t(`${mainButtonText}`)}
          type='button'
          buttonType='white'
          onClick={() => {
            onChange([...values, '']);
          }}
          icon={plusSignSVG}
        />
      </div>
      <div className='multiInput--items'>
        {values.map((value, index) => (
          <div key={index} className='multiInput__item'>
            <input
              type='text'
              value={value}
              placeholder={t(`${inputPlaceholder}`)}
              className='multiInput__item--input'
              onChange={(e) => {
                const newValues = [...values];
                newValues[index] = e.target.value;
                onChange(newValues);
              }}
            />
            <div
              className='multiInput__item--button'
              onClick={() => {
                const newValues = values.filter((_, i) => i !== index);
                onChange(newValues);
              }}
            >
              <CustomSVGs svg={crossSVG} />
            </div>
          </div>
        ))}
        {/* <div className='multiInput__item'>
          <input
            type='text'
            placeholder={t(`${inputPlaceholder}`)}
            className='multiInput__item--input'
          />
          <div className='multiInput__item--button'>
            <CustomSVGs svg={crossSVG} />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default MultiInput;
